"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSectionHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
require("./types");
const Root = styled_components_1.default(components_1.StackView).attrs({
    direction: components_1.STACK_DIRECTION.column,
    gap: components_1.STACK_GAP.s,
}) ``;
Root.displayName = 'PageSectionHeaderRoot';
const PageSectionHeader = ({ title, description } = {}) => {
    if (!title && !description) {
        return null;
    }
    return (react_1.default.createElement(Root, null,
        react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.l, weight: components_1.TEXT_WEIGHT.bold }, title),
        description && react_1.default.createElement(components_1.Text, { view: components_1.TEXT_VIEW.primary }, description)));
};
exports.PageSectionHeader = PageSectionHeader;
exports.PageSectionHeader.displayName = 'PageSectionHeader';
//# sourceMappingURL=PageSectionHeader.js.map